import * as React from "react";
import { Box, Button, Rating, TextField } from "@mui/material";
import { ProjectResource } from "../../../types/project";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import BaseModal from "../../../components/global/BaseModal";

const GiveReviewModal = ({
  open,
  onClose,
  onSubmit,
  job,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (
    resource_id: number,
    star: number,
    message: string
  ) => Promise<void>;
  job: ProjectResource | null;
}) => {
  const [star, setStar] = React.useState(0);
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = () => {
    if (!star || !message) {
      toast.error("Please fill in all the required fields.");
      return;
    }
    setLoading(true);
    onSubmit(job?.resource_id!, star, message).finally(() => {
      setLoading(false);
      onClose();
    });
  };

  React.useEffect(() => {
    if (open) {
      setStar(0);
      setMessage("");
    }
  }, [open]);

  const footer = (
    <>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <LoadingButton onClick={handleSubmit} loading={loading}>
        Submit Review
      </LoadingButton>
    </>
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={`Review for ${job?.resource?.full_name || "Independent Professional"}`}
      footer={footer}
      maxWidth="sm"
    >
      <Box sx={{ p: 3, display: "grid", gap: 2 }}>
        <Rating
          value={star}
          readOnly={false}
          size="large"
          onChange={(e, newVal) => setStar(newVal || 0)}
          precision={0.5}
        />
        <TextField
          label="Review message"
          fullWidth
          multiline
          minRows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Box>
    </BaseModal>
  );
};
export default GiveReviewModal;
